import { useContext } from "react";

import { Portal } from "@blueprintjs/core";
import { Widget, WidgetProps } from "@typeform/embed-react";

import { Box } from "@/components/layout/flexbox";
import { PageSizeContext } from "@/components/layout/PageSize";
import { BackDrop } from "@/components/pieces/BackDrop";
import { ScrollableModal } from "@/components/pieces/ScrollableModal";
import { CARD_CLASSES, PORTAL_Z_INDEX } from "@/css/constants";

interface TypeformProps extends WidgetProps {
  id: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  success: React.ReactNode;
}

export function Typeform({
  id,
  visible,
  setVisible,
  success,
  ...props
}: TypeformProps) {
  const { windowHeight = 0, windowWidth = 0 } = useContext(PageSizeContext);
  const heightConstrained = windowWidth / windowHeight > 1.7;

  return (
    <Portal>
      <BackDrop
        visible={visible}
        zIndex={PORTAL_Z_INDEX}
        opacity={0.6}
        onClick={() => setVisible(false)}
      />
      <ScrollableModal
        visible={visible}
        onClose={() => setVisible(false)}
        verticallyCenter={true}
        canOutsideClickClose={true}
        style={{
          width: 800,
          maxWidth: heightConstrained ? windowHeight * 1.7 : "100%",
        }}
      >
        <Box backgroundColor="#FFF" className={CARD_CLASSES}>
          {success ? (
            success
          ) : (
            <Widget id={id} height={500} hideFooter={true} {...props} />
          )}
        </Box>
      </ScrollableModal>
    </Portal>
  );
}
